import React from "react"
import classnames from "classnames"
import * as styles from "./styles.module.css"

export const Row = ({
  children,
  gutter,
  style,
  justify,
}: {
  children: JSX.Element | Array<JSX.Element>
  gutter?: [number, number] | number
  style?: React.CSSProperties
  justify?: React.CSSProperties["justifyContent"]
}) => {
  const isGapNumber = typeof gutter === "number"

  const gap = (side: "row" | "col") =>
    gutter ? (isGapNumber ? gutter : gutter[side === "row" ? 0 : 1]) : 0

  return (
    <div
      style={{
        rowGap: gap("row"),
        columnGap: gap("col"),
        justifyContent: justify,
        ...style,
      }}
      className={classnames(styles.row)}
    >
      {children}
    </div>
  )
}
export const Col = ({
  children,
}: {
  children: JSX.Element | Array<JSX.Element>
  xs?: number
  md?: number
}) => <div>{children}</div>
